import _ from 'lodash';
/* eslint no-useless-escape:0 import/prefer-default-export:0 */

const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
export const isUrl = (path) => reg.test(path);

export const getPageQuery = () => URLSearchParams(window.location.href.split('?')[1]);

export const handleImage = (values, URL) => {
  const arr = _.without(_.split(values, '##'), '');
  let res = [];
  arr.forEach((i, index) => {
    res.push({
      uid: index,
      url: !(i.includes('https://') || i.includes('http://')) ? URL + i : i,
      path: i,
      name: i.substring(i.lastIndexOf('/') + 1),
    });
  });
  return res;
};

export const convertImage = (array) => {
  var temp = [];
  array.forEach((element) => {
    temp = _.concat(temp, element?.response?.data[0]?.url ?? element.path);
  });
  var res = _.uniq(temp).join('##');
  return res;
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
export const checkDateTime = (date1) => {
  date1 = new Date(date1);
  var date2 = new Date();
  return date2.getTime() > date1.getTime();
};
export const addMonthToTime = (dateTime, month) => {
  if (checkDateTime(dateTime)) {
    const date = new Date();
    const newDate = new Date(date.setMonth(date.getMonth() + month));
    return newDate;
  } else {
    const date = new Date(dateTime);
    const newDate = new Date(date.setMonth(date.getMonth() + month));
    return newDate;
  }
};
export const addDayToTime = (dateTime, day) => {
  if (checkDateTime(dateTime)) {
    const date = new Date();
    const newDate = new Date(date.setDate(date.getDate() + day));
    return newDate;
  } else {
    const date = new Date(dateTime);
    const newDate = new Date(date.setDate(date.getDate() + day));
    return newDate;
  }
};

export const dataTypeVehicle = [
  {
    label: 'Ô Tô',
    value: 'OTo',
    enum: 0b0001,
  },
  {
    label: 'Xe Máy',
    value: 'XeMay',
    enum: 0b0010,
  },
  {
    label: 'Xe Đạp',
    value: 'XeDap',
    enum: 0b0100,
  },
];
export const convertToReadableCode = (machineId) => {
  var num = Math.floor(machineId.length / 5);
  var num2 = machineId.length % 5;
  var list = [];
  var num3 = 0;
  if (num2 > 0) {
    num -= 2;
    num3 = 5 + Math.floor(num2 / 2);
    list.push(machineId.substring(0, num3));
  }

  for (var i = 0; i < num; i++) {
    list.push(machineId.substring(num3 + i * 5, num3 + i * 5 + 5));
  }

  if (num2 > 0) {
    var startIndex = num3 + num * 5;
    list.push(machineId.substring(startIndex));
  }

  return list.join('-');
};

export const ConvertPathToLinkNote = (path) => {
  const versionMatch = path.match(/(\d+\.\d+\.\d+-beta\.\d+)/);
  if (versionMatch && versionMatch[1]) {
    const version = versionMatch[1];
    return `release-notes-${version}.md`;
  } else {
    return null;
  }
};
// Hàm để lấy chuỗi phiên bản từ tên file
function extractVersion(filePath) {
  // Biểu thức chính quy để tìm chuỗi phiên bản
  const versionMatch = filePath.match(/(\d+\.\d+\.\d+-beta\.\d+)/);
  // Kiểm tra và trả về kết quả
  if (!versionMatch) {
    const versionMatch = filePath.match(/(\d+\.\d+\.\d+-beta)/);
    return versionMatch ? versionMatch[1] : null;
  }
  return versionMatch[1];
}

export function createReleaseNotesPath(filePath) {
  // Trích xuất chuỗi phiên bản
  const version = extractVersion(filePath);
  if (version) {
    // Thay thế phần cuối của đường dẫn bằng tên mới
    return filePath.replace(/\/[^\/]+$/, `/release-notes-${version}.md`);
  }
  // Nếu không tìm thấy phiên bản, trả về null hoặc giá trị khác tùy ý
  return null;
}

function extractVersionAlpha(filePath) {
  // Biểu thức chính quy để tìm chuỗi phiên bản
  const versionMatch = filePath.match(/(\d+\.\d+\.\d+-alpha\.\d+)/);
  // Kiểm tra và trả về kết quả
  return versionMatch ? versionMatch[1] : null;
}

// Hàm để tạo tên mới từ đường dẫn và chuỗi phiên bản
export function createReleaseNotesPathAlpha(filePath) {
  // Trích xuất chuỗi phiên bản
  const version = extractVersionAlpha(filePath);
  if (version) {
    // Thay thế phần cuối của đường dẫn bằng tên mới
    return filePath.replace(/\/[^\/]+$/, `/release-notes-${version}.md`);
  }
  // Nếu không tìm thấy phiên bản, trả về null hoặc giá trị khác tùy ý
  return null;
}
